import React from "react";
import MediaUploader from "../../../../components/common/formkit/MediaUploader";
import { Section } from "../../../../components/common/formkit/fields";

const Step3Medias = ({ form, setForm, nextStep, formId }) => {
  const images = form.images || [];
  const videos = form.videos || [];
  const attachments = form.attachments || [];

  // Same shapes the form has always stored: { type, url, name }
  const handleUploaded = ({ media, attachments: pdfs }) => {
    const uploadedMedia = media.map((m) => ({
      type: m.imagePath.endsWith(".mp4") ? "video" : "image",
      url: m.image_url,
      name: m.imagePath,
    }));
    const uploadedPdfs = pdfs.map((att) => ({
      type: "pdf",
      url: att.attachment_url,
      name: att.attachmentPath,
    }));
    setForm((prev) => ({
      ...prev,
      images: [...(prev.images || []), ...uploadedMedia.filter((m) => m.type === "image")],
      videos: [...(prev.videos || []), ...uploadedMedia.filter((m) => m.type === "video")],
      attachments: [...(prev.attachments || []), ...uploadedPdfs],
    }));
  };

  const listKey = { image: "images", video: "videos", pdf: "attachments" };

  const handleRemove = (item) => {
    const key = listKey[item.kind];
    setForm((prev) => ({ ...prev, [key]: (prev[key] || []).filter((_, i) => i !== item.index) }));
  };

  const handleMove = (item, direction) => {
    const key = listKey[item.kind];
    setForm((prev) => {
      const list = [...(prev[key] || [])];
      const target = item.index + direction;
      if (target < 0 || target >= list.length) return prev;
      [list[item.index], list[target]] = [list[target], list[item.index]];
      return { ...prev, [key]: list };
    });
  };

  const toItems = (list, kind) =>
    list.map((m, index) => ({
      id: `${kind}-${index}-${m.url}`,
      kind,
      url: m.url,
      name: m.name,
      index,
      isLast: index === list.length - 1,
    }));

  const items = [...toItems(images, "image"), ...toItems(videos, "video"), ...toItems(attachments, "pdf")];

  return (
    <form
      id={formId}
      noValidate
      onSubmit={(e) => {
        e.preventDefault();
        if (nextStep) nextStep();
      }}
    >
      <Section
        title="Photos, videos & documents"
        hint="Optional. The first image is used as the cover. Use the arrows on a thumbnail to reorder."
      >
        <MediaUploader items={items} onUploaded={handleUploaded} onRemove={handleRemove} onMove={handleMove} />
      </Section>
    </form>
  );
};

export default Step3Medias;
